import i18n from '@/i18n'

const getRandomInt = (min, max) => {
  min = Math.ceil(min)

  max = Math.floor(max)

  return Math.floor(Math.random() * (max - min + 1)) + min
}

const letters = 'ABCDEFGHIJKLMNOPQRSTUVXWYZ'.split('')

const getColors = () => [
  i18n.t('colors.FF0000'),
  i18n.t('colors.FFFF00'),
  i18n.t('colors.0000FF'),
  i18n.t('colors.808080'),
  i18n.t('colors.00FF00'),
  i18n.t('colors.7F007F')
]

export default () => {
  const colors = getColors()

  const randomColor = colors[getRandomInt(0, colors.length - 1)]

  const surname = letters[getRandomInt(0, letters.length - 1)]

  if (i18n.locale && i18n.locale.startsWith('en')) {
    return `${randomColor} ${surname}.`
  } else {
    return `Octo ${surname}. ${randomColor}`
  }
}
